export const UpdateYaantracData = () => {
  return [
    {
      id: '1',
      label: 'DOT Inspection Date',
      name: 'dotInspectionDate',
      placeholder: 'DOT Inspection Date',
      inputProps: { maxLength: 40 },
      type: 'string',
      required: 'Select DOT inspection date',
      test: true,
      testCase: function (this: any) {
        const { dotInspectionDate } = this.parent;
        return Number(dotInspectionDate) < Math.floor(Date.now() / 1000);
      },
      testName: 'invalid-date',
      testMessage: 'Invalid DOT inspection date'
    },
    {
      id: '2',
      label: 'Insurance Expiry Date',
      name: 'insuranceExpiryDate',
      placeholder: 'Insurance Expiry Date',
      inputProps: { maxLength: 40 },
      type: 'string',
      required: 'Select insurance expiry date',
      test: true,
      testCase: function (this: any) {
        const { insuranceExpiryDate } = this.parent;
        return Number(insuranceExpiryDate) > Math.floor(Date.now() / 1000);
      },
      testName: 'invalid-date',
      testMessage: 'Invalid insurance expiry date'
    },
    {
      id: '3',
      label: 'Last Service Date',
      name: 'lastServiceDate',
      placeholder: 'Last Service Date',
      inputProps: { maxLength: 10 },
      type: 'string',
      required: 'Select last service date',
      test: true,
      testCase: function (this: any) {
        const { lastServiceDate } = this.parent;
        return Number(lastServiceDate) < Math.floor(Date.now() / 1000);
      },
      testName: 'invalid-date',
      testMessage: 'Invalid last service date'
    },
    {
      id: '4',
      label: 'Overspeed Limit',
      name: 'overspeedLimit',
      placeholder: 'Overspeed Limit',
      inputProps: { maxLength: 10 },
      notRequired: true
    },
    {
      id: '5',
      label: 'Free Way',
      name: 'freeWay',
      placeholder: 'Free Way',
      inputProps: { maxLength: 10 },
      type: 'number',
      required: 'Enter  Freeway overspeed limit',
      min: 91,
      minMessage: 'Free way speed limit  should be between 91 and 120',
      max: 120,
      maxMessage: 'Free way speed limit  should be between 91 and 120'
    },
    {
      id: '6',
      label: 'Non-Free Way',
      name: 'nonFreeWay',
      placeholder: 'Non-Free Way',
      inputProps: { maxLength: 10 },
      type: 'number',
      required: 'Enter Non-freeway overspeed limit',
      min: 50,
      minMessage: 'Non-freeway way speed limit  should be between 91 and 120',
      max: 90,
      maxMessage: 'Non-freeway way speed limit  should be between 91 and 120'
    }
  ];
};
